export const MULTI_COLUMN_GAP = {
  SIZE_10: '--column-gap-size-10',
} as const
export type MULTI_COLUMN_GAP =
  (typeof MULTI_COLUMN_GAP)[keyof typeof MULTI_COLUMN_GAP]
